import styled from "styled-components";

// EOS Specific Styles
export const CheckboxContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  margin-bottom: 1rem;
`;

export const CheckboxLabel = styled.label`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.9rem;
  color: ${props => props.isDarkMode ? '#cbd5e0' : '#4a5568'};\n  cursor: pointer;
  transition: color 0.2s;

  &:hover {
    color: #667eea;
  }

  input[type="checkbox"] {
    width: 16px;
    height: 16px;
    cursor: pointer;
    accent-color: #667eea;
  }
`;
